import { useContext } from 'react'
import { Box, Typography } from '@mui/material'
import { CustomModal } from '@mth/components/CustomModal/CustomModals'
import { fontFamilyEnum } from '@mth/enums'
import { UseOpenedMagicLink } from '@mth/hooks/useOpenedMagicLink/UseOpenedMagicLink'
import { UserContext } from '@mth/providers/UserContext/UserProvider'
import { ITRModalType } from './itrModal.type'
import { MthLoadingWrapper } from '../shared/MthLoadingWrapper/MthLoadingWrapper'

export const ITRModal: React.FC<ITRModalType> = ({ onCancel, onSubmit }) => {
  const { me } = useContext(UserContext)

  const onSubmitCallback = async () => {
    if (onSubmit) await onSubmit(true)
  }
  const { loading, displayOpenedTab } = UseOpenedMagicLink({ userId: Number(me?.user_id), callback: onSubmitCallback })

  const displaySwitch = () => {
    return (
      <MthLoadingWrapper loading={loading} minHeight='10px'>
        <Box>
          <Typography
            sx={{ marginBottom: '15px', marginTop: '10px', fontSize: 14, fontFamily: fontFamilyEnum.HeavyFont }}
          >
            Great news: OpenEd&apos;s new platform for the 2025-26 school year and beyond is <strong>now live!</strong>{' '}
            <button
              onClick={displayOpenedTab}
              style={{
                all: 'unset', // resets most native button styles
                color: 'blue',
                cursor: 'pointer',
                textDecoration: 'underline',
                display: 'inline',
              }}
            >
              {' '}
              Click here
            </button>{' '}
            to begin your enrollment tasks.
          </Typography>
          <Typography
            sx={{ marginBottom: '15px', marginTop: '10px', fontSize: 14, fontFamily: fontFamilyEnum.HeavyFont }}
          >
            All of your account information from InfoCenter has already been synced, so you&apos;ll start off with some
            tasks completed!
          </Typography>
          <Typography
            sx={{
              marginBottom: '15px',
              marginTop: '10px',
              fontSize: 14,
              fontFamily: fontFamilyEnum.HeavyFont,
              fontStyle: 'italic',
            }}
          >
            Haven&apos;t submitted your ITR yet? No problem—this process includes everything you need.
          </Typography>
        </Box>
      </MthLoadingWrapper>
    )
  }

  return (
    <CustomModal
      title='Intent to Re-enroll'
      description={`It's time to get ready for the 2025–26 school year!`}
      descriptionSx={{ fontSize: 17, fontFamily: fontFamilyEnum.HeavyFont, fontWeight: 'bold' }}
      subDescription={displaySwitch()}
      confirmStr={'Close'}
      cancelStr='Cancel'
      onClose={onCancel}
      showCancel={false}
      onConfirm={onCancel}
      modalSx={{ maxWidth: 620, maxHeight: '90vh', overflow: 'auto' }}
    />
  )
}
